import { req } from '../../@api/request';

export default class AlgorithmService {
  static getAlgorithmList = async (
    isSaved: 'Y' | 'N',
    limit: number,
    page: number,
  ) => {
    const result = await req.get('/algorithm', {
      params: {
        is_saved: isSaved,
        limit,
        page,
      },
    });
    return result.data;
  };

  static createAlgorithm = async (data: any) => {
    const result = await req.post(`/algorithm`, data);
    return result.data;
  };

  static saveAlgorithm = async (algorithmIdx: number, data: any) => {
    const result = await req.post(`/algorithm/${algorithmIdx}`, data);
    return result.data;
  };

  static deleteAlgorithm = async (algorithmIdx: number) => {
    const result = await req.delete(`/algorithm/${algorithmIdx}`);
    return result.data;
  };

  static getAlgorithmAnalysis = async (algorithmIdx: number) => {
    const result = await req.get(`/algorithm/analysis/${algorithmIdx}`);
    return result.data;
  };

  static getAlgorithmRecommend = async (
    algorithmIdx: number,
    sort: string,
    limit: number,
    page: number,
    pnu?: string,
    category?: string,
    categoryDetail?: string,
    minPrice?: number,
    maxPrice?: number,
  ) => {
    const result = await req.get(`/algorithm/recommend/${algorithmIdx}`, {
      params: {
        sort,
        limit,
        page,
        pnu,
        category,
        categoryDetail,
        minPrice,
        maxPrice,
      },
    });
    return result.data;
  };

  static getRecommendAlgorithmList = async (limit: number, page: number) => {
    const result = await req.get(`/algorithm/recommend`, {
      params: { limit, page },
    });
    return result.data;
  };
}
